import "../../stylesheets2025/Awards.css";

const Awards = () => {
    return (
        <div className="awards-container">
            {/* Header Section */}
            <header className="awards-header">
                <h1>Awards & Recognitions</h1>
                <p>
                    To acknowledge and celebrate excellence in research and innovation
                    aligned with the spirit of sustainable living, the LiFE 2025
                    Conference will confer the following awards:
                </p>
            </header>

            {/* Awards List */}
            <section className="awards-grid">
                <div className="award-card">
                    <div className="award-icon">🏆</div>
                    <h2>Outstanding Research Paper Award</h2>
                    <p>
                        For exemplary quality, originality, and relevance in paper
                        presentations.
                    </p>
                </div>

                <div className="award-card">
                    <div className="award-icon">🎖️</div>
                    <h2>Outstanding Poster Presentation Award</h2>
                    <p>
                        For clarity, creativity, and scientific merit in poster displays.
                    </p>
                </div>

                <div className="award-card">
                    <div className="award-icon">🌿</div>
                    <h2>Special Recognition for Research Contribution (Paper)</h2>
                    <p>
                        For notable efforts and insights contributing to the conference
                        theme.
                    </p>
                </div>

                <div className="award-card">
                    <div className="award-icon">💡</div>
                    <h2>Special Mention for Poster Presentation</h2>
                    <p>
                        For commendable presentation and impactful visual communication.
                    </p>
                </div>
            </section>

            {/* Footer Note */}
            <footer className="awards-footer">
                <p>
                    All awardees will be recognized during the{" "}
                    <strong>Valedictory Session</strong> and will receive{" "}
                    <strong>Certificates of Appreciation</strong> for their contributions.
                </p>
            </footer>
        </div>
    );
};

export default Awards;
